module.exports = __webpack_public_path__ + "img/瑞日鏵_LOGO_320x150.025dbc8f.png";